"use strict";
/**
 * Features & Types
 *
 * Both are lowercased, simple words that explain the feature/type to the best of our knowledge and belief, without dashes or dots.
 * - Feature is always singular. Think of a feature as a name for the feature: pim, custom, workflow, checkin, email etc.
 * - Type is always plural. The type should be present in the Restful API path at the last position and therefor has to be plural. The type should match the collection name.
 *
 * Copied from https://gitlab.com/smallstack/smallstack/-/wikis/Coding-Guidelines
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.T_DATATYPE = exports.F_DATATYPE = exports.T_CRONJOB = exports.F_CRONJOB = exports.T_DASHBOARD = exports.F_DASHBOARD = exports.T_TASK = exports.F_TASK = exports.T_MAILING_CHANNELS = exports.T_MAILING_LISTS = exports.F_MAILING = exports.T_MESSAGE = exports.F_MESSAGE = exports.T_ORDER = exports.F_ORDER = exports.T_PRICEZONE = exports.F_PRICEZONE = exports.T_SHOPPING_CART = exports.F_SHOPPING_CART = exports.T_SUPPLIER = exports.F_SUPPLIER = exports.T_CUSTOM_BACKOFFICE = exports.F_CUSTOM_BACKOFFICE = exports.T_PRODUCTS = exports.T_PIM = exports.F_PIM = exports.F_PDF_TEMPLATES = exports.T_DEVICE = exports.F_DEVICE = exports.T_WORKFLOW = exports.F_WORKFLOW = exports.T_CONFIGURATION = exports.F_CONFIGURATION = exports.T_OPTIN = exports.F_OPTIN = exports.T_CUSTOMERS = exports.T_USERS = exports.F_USER = exports.T_APPLICATION = exports.F_APPLICATION = exports.T_CMS_PAGE = exports.F_CMS = exports.T_FORMS = exports.F_FORM = exports.T_CHECKIN_PRINTER_CONFIGURATIONS = exports.T_CHECKIN_APP = exports.T_CHECKIN_VISIT_EVENT = exports.T_CHECKIN_VISITOR = exports.F_CHECKIN = exports.F_CUSTOM = void 0;
exports.T_WORKLOGS = exports.T_PDF_TEMPLATES = exports.T_SUBSCRIPTIONS = exports.T_TODO_TEMPLATES = exports.T_TODOS = exports.T_CONTACT = exports.F_CONTACT = exports.T_EXTENSION_SLOTS = exports.F_EXTENSION = exports.T_FILE = exports.F_FILE = exports.T_CALENDAR_ENTRIES = exports.T_CALENDARS = exports.F_CALENDAR = exports.F_IMPEX = exports.T_EMAIL_TEMPLATE = exports.T_EMAIL = exports.F_EMAIL = exports.T_TRANSLATION = exports.T_LANGUAGE = exports.T_COUNTRY = exports.T_LOCALE = exports.F_I18N = void 0;
const static_types_1 = require("./static-types");
exports.F_CUSTOM = "custom";
exports.F_CHECKIN = "checkin";
exports.T_CHECKIN_VISITOR = "visitor";
exports.T_CHECKIN_VISIT_EVENT = "visitorevent";
exports.T_CHECKIN_APP = "app";
exports.T_CHECKIN_PRINTER_CONFIGURATIONS = "printerconfigurations";
exports.F_FORM = "forms";
exports.T_FORMS = "form";
exports.F_CMS = "cms";
exports.T_CMS_PAGE = static_types_1.CmsPageType.name;
exports.F_APPLICATION = "applications";
exports.T_APPLICATION = "application";
exports.F_USER = "user";
exports.T_USERS = "users";
exports.T_CUSTOMERS = "customers";
exports.F_OPTIN = "optin";
exports.T_OPTIN = "optin";
exports.F_CONFIGURATION = "configuration";
exports.T_CONFIGURATION = "configuration";
exports.F_WORKFLOW = "workflow";
exports.T_WORKFLOW = static_types_1.WorkflowType.name;
exports.F_DEVICE = "devices";
exports.T_DEVICE = "devices";
exports.F_PDF_TEMPLATES = "pdftemplates";
exports.F_PIM = "products";
/** @deprecated use T_PRODUCTS */
exports.T_PIM = "products";
exports.T_PRODUCTS = static_types_1.ProductType.name;
exports.F_CUSTOM_BACKOFFICE = "custombackoffices";
exports.T_CUSTOM_BACKOFFICE = "custombackoffices";
exports.F_SUPPLIER = "suppliers";
exports.T_SUPPLIER = "supplier";
exports.F_SHOPPING_CART = "shoppingcarts";
exports.T_SHOPPING_CART = "shoppingcarts";
exports.F_PRICEZONE = "pricezones";
exports.T_PRICEZONE = "pricezones";
exports.F_ORDER = "orders";
exports.T_ORDER = "orders";
exports.F_MESSAGE = "messages";
exports.T_MESSAGE = "messages";
exports.F_MAILING = "mailing";
exports.T_MAILING_LISTS = "mailinglists";
exports.T_MAILING_CHANNELS = "mailingchannels";
exports.F_TASK = "tasks";
exports.T_TASK = "task";
exports.F_DASHBOARD = "dashboards";
exports.T_DASHBOARD = "dashboard";
exports.F_CRONJOB = "cronjobs";
exports.T_CRONJOB = "cronjob";
exports.F_DATATYPE = "datatypes";
exports.T_DATATYPE = "datatypes";
exports.F_I18N = "internationalization";
exports.T_LOCALE = "locale";
exports.T_COUNTRY = "country";
exports.T_LANGUAGE = "language";
exports.T_TRANSLATION = "translations";
exports.F_EMAIL = "email";
exports.T_EMAIL = "emails";
exports.T_EMAIL_TEMPLATE = "emailtemplates";
exports.F_IMPEX = "impex";
exports.F_CALENDAR = "calendar";
exports.T_CALENDARS = static_types_1.CalendarType.name;
exports.T_CALENDAR_ENTRIES = static_types_1.CalendarEntryType.name;
exports.F_FILE = "files";
exports.T_FILE = static_types_1.FileType.name;
exports.F_EXTENSION = "extension";
exports.T_EXTENSION_SLOTS = "extensionslots";
exports.F_CONTACT = "contact";
exports.T_CONTACT = "contacts";
exports.T_TODOS = static_types_1.TodoType.name;
exports.T_TODO_TEMPLATES = static_types_1.TodoTemplateType.name;
exports.T_SUBSCRIPTIONS = static_types_1.SubscriptionType.name;
exports.T_PDF_TEMPLATES = static_types_1.PdfTemplateType.name;
exports.T_WORKLOGS = "worklogs";
